import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/ai/assistantsFiles', request)
}

export {post}
